import { HUB } from "@/interfaces/HUB";
import { ReturnRequest } from "@/interfaces/Return";
import { Seller } from "@/interfaces/Seller";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import storage from "redux-persist/lib/storage";

export const requestReturnHeaderPersistConfig = {
  key: "requestReturnHeader",
  storage,
  whitelist: ["returnCode", "seller", "requests", "source", "dropOff"],
};

export interface RequestReturnHeaderState {
  returnCode: number;
  seller: Seller;
  request: ReturnRequest;
  source: number;
  dropOff: HUB;
}

const initialState: RequestReturnHeaderState = {
  returnCode: 0,
  seller: {} as Seller,
  request: {} as ReturnRequest,
  source: 0,
  dropOff: {} as HUB,
};

const requestReturnHeaderSlice = createSlice({
  name: "returnCreate",
  initialState,
  reducers: {
    setRequestReturnHeader: (
      state,
      action: PayloadAction<RequestReturnHeaderState>
    ) => {
      state.returnCode = action.payload.returnCode;
      state.seller = action.payload.seller;
      state.request = action.payload.request;
      state.source = action.payload.source;
      state.dropOff = action.payload.dropOff;
    },
    resetReturnHeader: (state) => {
      state.returnCode = 0;
      state.seller = {} as Seller;
      state.request = {} as ReturnRequest;
      state.source = 0;
      state.dropOff = {} as HUB;
    },
  },
});

export const { setRequestReturnHeader, resetReturnHeader } =
  requestReturnHeaderSlice.actions;
export default requestReturnHeaderSlice.reducer;
